import React, { useEffect, useRef, useState } from 'react';

// Кнопка «Sign in with Google» (Epic 7). Вторая дверь в тот же аккаунт:
// вход по паролю продолжает работать всегда. Скрипт Google подключаем
// динамически, чтобы страница входа не зависела от него при загрузке.
const GSI_SRC = 'https://accounts.google.com/gsi/client';
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

// Промис кешируем на уровне модуля: скрипт сообщает load/error ровно один
// раз, поэтому вешать слушатели на уже отработавший тег бессмысленно —
// повторное монтирование зависало бы навсегда (ревью 07.08).
let gsiPromise = null;

function loadGsi() {
    if (window.google?.accounts?.id) return Promise.resolve();
    if (gsiPromise) return gsiPromise;
    gsiPromise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = GSI_SRC;
        s.async = true;
        s.defer = true;
        s.onload = resolve;
        s.onerror = () => reject(new Error('Failed to load Google sign-in'));
        document.head.appendChild(s);
    });
    return gsiPromise;
}

function GoogleSignInButton({ onCredential }) {
    const holderRef = useRef(null);
    const [failed, setFailed] = useState(false);
    // Колбэк в ref: Google вызывает его из своего замыкания, пересоздавать
    // кнопку на каждый рендер родителя не нужно.
    const cbRef = useRef(onCredential);
    cbRef.current = onCredential;

    useEffect(() => {
        if (!CLIENT_ID) return;
        let alive = true;
        loadGsi()
            .then(() => {
                if (!alive || !holderRef.current) return;
                window.google.accounts.id.initialize({
                    client_id: CLIENT_ID,
                    callback: (resp) => cbRef.current && cbRef.current(resp.credential),
                });
                // Ширину не задаём: у Google это МИНИМУМ, и на узких экранах
                // кнопка вылезала бы за колонку формы.
                holderRef.current.innerHTML = '';
                window.google.accounts.id.renderButton(holderRef.current, {
                    theme: 'outline',
                    size: 'large',
                    text: 'signin_with',
                });
            })
            .catch(() => { if (alive) setFailed(true); });
        return () => { alive = false; };
    }, []);

    // Ключ не задан или скрипт не загрузился — просто не показываем кнопку,
    // вход по паролю на странице остаётся рабочим.
    if (!CLIENT_ID || failed) return null;

    return (
        <div className="google-signin">
            <div className="google-signin__divider"><span>or</span></div>
            <div ref={holderRef} className="google-signin__button" />
        </div>
    );
}

export default GoogleSignInButton;
